import { SvgComponentProps } from "@/src/types/SVGPropType";
import * as React from "react";
const Enterprise5SVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="#EDEDED"
      fillRule="evenodd"
      d="M6.003 2.873a6.453 6.453 0 0 1 1.973-.527L7.822.854a7.953 7.953 0 0 0-2.43.65l.611 1.37Zm3.326-.527a6.501 6.501 0 1 1-7.142 7.142l-1.492.154A8.001 8.001 0 1 0 9.483.854L9.33 2.346ZM3.392 4.992a6.542 6.542 0 0 1 1.44-1.441L3.95 2.338A8.042 8.042 0 0 0 2.18 4.11l1.212.883ZM2.187 8.134c.072-.697.254-1.36.528-1.972l-1.37-.613a7.953 7.953 0 0 0-.65 2.43l1.492.155ZM9.403 5.56v-.75h-1.5v3.875a1 1 0 0 0 .4.8l1.9 1.425.6.45.9-1.2-.6-.45-1.7-1.275V5.56Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Enterprise5SVG;
